// src/components/routes/AppRouter.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Landing from "../pages/landing/Landing"
import Login from "../pages/auth/Login"
import SignUp from "../pages/auth/SignUp"
import { useAuth } from "../data/useAuth"
import axios from "axios"
import Dashboard from "../pages/dashboard/Dashboard"
// import { useEffect } from "react"
import ProductPage from "../pages/productPage/ProductPage"
import SingleProductPage from "../pages/productPage/SingleProductPage"
import ForgotPassword from "../pages/auth/ForgotPassword"
import ResetPassword from "../pages/auth/ResetPassword"
import ActivateAccount from "../pages/auth/ActivateAccount"
import Cart from "../icons/Cart"
import CartPage from "../pages/cart/CartPage"
import SuccessPage from "../pages/orders/SuccessPage"
import CategoryPage from "../pages/category/CategoryPage"
import AccountPage from "../pages/Account/AccountPage"
import AddressPage from "../pages/Address/AddressPage"
import DeliveryStatePage from "../pages/delivieryState/deliveryState"
import OrderSummary from "../pages/orders/OrderSummary"
import GeneralOrder from "../pages/orders/GeneralOrdersPage"
import SingleOrderGeneal from "../pages/orders/SingleOrderGenral"
import EmployeePage from "../pages/employee/Employee"
import AdminOrdersPage from "../pages/orders/AdminOrdersPage"
import Policies from "../policy/Policy"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { attemptTokenRefresh } from "../common/utils/auth.helper"
import PrivacyPolicy from "../policy/PrivacyPolicy"
import RefundPolicy from "../policy/RefundPolicy"
import ShippingPolicy from "../policy/ShippingPolicy"
import TermsOfService from "../policy/TermsAndServices"
import AboutUs from "../policy/AboutUs"
import ChargePage from "../pages/Charge/Charge"
function AppRouter() {
  const { user, isLoggedIn } = useAuth()
  // axios.defaults.headers.common["Authorization"] = `Bearer ${user?.token}`;
  // axios.defaults.baseURL = import.meta.env.VITE_BACKEND_URL;

  axios.defaults.baseURL = import.meta.env.VITE_BACKEND_URL
  axios.defaults.withCredentials = true
  // useEffect(() => {
  //   // Perform any side effects or data fetching here
  //   console.log("AppRouter mounted", user)
  //   console.log("login", isLoggedIn)
  // }, [user])

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isLoggedIn) {
      attemptTokenRefresh(dispatch)
    }
  }, [isLoggedIn])
  useEffect(() => {
    const interval = setInterval(() => {
      attemptTokenRefresh(dispatch)
    }, 12 * 60 * 1000) // every 12 minutes
    return () => clearInterval(interval)
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route
          index
          element={
            !isLoggedIn ? (
              <Landing />
            ) : user.is_admin ? (
              <Dashboard />
            ) : (
              <Landing />
            )
          }
        />
        <Route path="login" element={<Login />} />
        <Route path="sign-up" element={<SignUp />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="activate-account" element={<ActivateAccount />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="product/:id" element={<SingleProductPage />} />
        <Route path="/products" element={<Landing />} />
        <Route
          path="product"
          element={isLoggedIn && user.is_admin ? <ProductPage /> : <Landing />}
        />
        <Route path="cart" element={isLoggedIn ? <OrderSummary /> : <Login />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route
          path="/category"
          element={isLoggedIn ? <CategoryPage /> : <Login />}
        />
        <Route
          path="/account"
          element={isLoggedIn ? <AccountPage /> : <Login />}
        />
        <Route
          path="/address"
          element={isLoggedIn ? <AddressPage /> : <Login />}
        />
        <Route
          path="/delivery"
          element={isLoggedIn ? <DeliveryStatePage /> : <Login />}
        />
        <Route
          path="/charge"
          element={isLoggedIn ? <ChargePage /> : <Login />}
        />
        <Route
          path="/order-summary/:data"
          element={isLoggedIn ? <OrderSummary /> : <Login />}
        />
        <Route
          path="/orders"
          element={
            isLoggedIn ? (
              user.is_admin ? (
                <AdminOrdersPage />
              ) : (
                <GeneralOrder />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route path="/policy" element={<Policies />} />
        <Route
          path="/orders/:id"
          element={isLoggedIn ? <SingleOrderGeneal /> : <Login />}
        />
        <Route
          path="/employee"
          element={isLoggedIn ? <EmployeePage /> : <Login />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/about-us" element={<AboutUs />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter
